import { Button, Result } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from './common/constants';

const Error404 = () => (
  <Result
    status="404"
    title="404"
    subTitle="Sorry, the page you visited does not exist."
    extra={
      <Link to={ROUTES?.MAIN}>
        <Button type="primary">Back Home</Button>
      </Link>
    }
  />
);

export default Error404;
